export default __webpack_public_path__ + "static/media/25.e9e84b41.mp3";